import React, {Component} from 'react';
import { Link, NavLink } from 'react-router-dom'

import PropTypes from "prop-types";

class AppLink extends Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    type: PropTypes.string,
    className: PropTypes.string
  };

  onLinkClick(e) {
    window.scrollTo(0,0);

    if (typeof this.props.onClick === "function") {
      this.props.onClick();
    }
  }

  render() {
    if (this.props.to && this.props.to.substring(0, 4) === "http") {
      return <a href={this.props.to} target={"_blank"} rel={"noreferrer"}>{this.props.children}</a>
    }

    switch (this.props.type) {
      case "nav":
        return (
          <NavLink {...this.props} exact={true} className={this.props.className} to={this.props.to} onClick={() => { window.scrollTo(0,0); }}>{this.props.children}</NavLink>
        );
      default:
        return (
          <Link {...this.props} onClick={this.onLinkClick.bind(this)} className={this.props.className} to={this.props.to}>{this.props.children}</Link>
        );
    }
  }
}

export default AppLink;